const FEE = 0
const SALARY = 1
export { FEE, SALARY }
